import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const HorizontalCardInfoContainer = styled.div<{
  info?: boolean;
  plan?: boolean;
  progressBar?: boolean;
}>`
  display: flex;
  flex-direction: column;
  min-height: ${70 * Screen.widthRatio}px;
  justify-content: ${(props) => (props.info && !props.plan ? 'end' : 'start')};
  margin-left: ${Screen.widthRatio * 26}px;
  position: absolute;
  bottom: ${(props) => Screen.widthRatio * (props.progressBar ? -131 : -146)}px;
  width: ${Screen.widthRatio * 295}px;
`;

export default HorizontalCardInfoContainer;
